import * as types from "../action/ActionType";

interface NotificationCountAction {
  type: string;
  payload: number;
}

export default function NotificationCountReducer(
  state: number = 0,
  action: NotificationCountAction
): number {
  const { type, payload } = action;
  switch (type) {
    case types.NOTIFY_COUNT:
      return payload;
    default:
      return state;
  }
}
